import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import {
    BlobTypeStoreReadSettingsAdapter,
    blobTypeStoreReadSettingsAdapts
} from './blob-type-store-read-settings.adapter';
import { AzureBlobFSStoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/azure-blob-fs-read-settings';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { CopySource } from 'app/model/pipeline/copysource/copysource';

export const adapts = {
    deleteFilesAfterCompletion: '*',
    ...blobTypeStoreReadSettingsAdapts
};

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureBlobFSStoreReadSettings),
    asynchronous: true,
    adapts
})
export class AzureBlobFSStoreReadSettingsAdapter extends BlobTypeStoreReadSettingsAdapter<
    AzureBlobFSStoreReadSettings,
    Model.StoreReadSettings
> {
    protected override async _toModel(
        resource: Model.StoreReadSettings,
        copySource: CopySource
    ): Promise<AzureBlobFSStoreReadSettings> {
        const model = await super._toModel(resource, copySource);
        ValueAdapter.toModel(
            model,
            AzureBlobFSStoreReadSettings.DELETE_FILE_AFTER_COMPLETION,
            resource.deleteFilesAfterCompletion
        );
        return model;
    }

    protected override async _toResource(settings: AzureBlobFSStoreReadSettings): Promise<Model.StoreReadSettings> {
        const resource = await super._toResource(settings);
        if (resource != null) {
            resource.deleteFilesAfterCompletion = ValueAdapter.toResource(
                settings,
                AzureBlobFSStoreReadSettings.DELETE_FILE_AFTER_COMPLETION
            );
        }
        return resource;
    }
}
